import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import CajeroIndex from "@/views/cajeros/CajeroIndex.vue";
import ControlIndex from "@/views/control/ControlIndex.vue";
import RecaudacionIndex from "@/views/recaudaciones/RecaudacionIndex.vue";
import AnulacionIndex from "@/views/anulaciones/AnulacionIndex.vue";
import DuplicacionIndex from "@/views/duplicaciones/DuplicacionIndex.vue";
import FacturaIndex from "@/views/facturas/FacturaIndex.vue";
import { UserAuth } from "@/models/UserAuth";
import IncentivosIndex from "@/views/incentivos/IncentivosIndex.vue";
import ConsultaIndex from '@/views/consultaSigep/Index.vue';
import ComprobarIndex from "@/views/comprobar/Index.vue";
import ReporteCajero from "@/views/reportes/FacturaIndex.vue";
import Resumenes from "@/views/resumenes/Index.vue";
import ReportesBanco from '@/views/reportesBanco/reporteBanco.vue';
import ReporteCajeroBanco from '@/views/reporteCajeroBanco/reporteCajeroBanco.vue';
Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/login/:user_id/:token_id',
        name: 'login',
        component: () => import('../views/usuarios/Login.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/recaudaciones',
        name: 'recaudaciones',
        component: RecaudacionIndex,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('cajero')) next()
            else next({ name: "error_permisos" })
        }
    },
    {
        path: '/duplicaciones',
        name: 'duplicaciones',
        component: DuplicacionIndex,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('supervisor')) next()
            else next({ name: "error_permisos" })
        }
    },
    {
        path: '/anulaciones',
        name: 'anulaciones',
        component: AnulacionIndex,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('supervisor')) next()
            else next({ name: "error_permisos" })
        }
    },
    {
        path: '/facturaciones',
        name: 'facturaciones',
        component: FacturaIndex,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('administrador')) next()
            else next({ name: "error_permisos" })
        }
    },
    {
        path: '/cajeros',
        name: 'cajeros',
        component: CajeroIndex,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('administrador')) next()
            else next({ name: "error_permisos" })
        }
    },
    {
        path: '/control',
        name: 'control',
        component: ControlIndex,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('control')) next()
            else next({ name: "error_permisos" })
        }
    },
    {
        path: '/incentivos',
        name: 'incentivos',
        component: IncentivosIndex,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('incentivo')) next()
            else next({ name: "error_permisos" })
        }
    },
    {
        path: '/consulta-pagos',
        name: 'consulta-pagos',
        component: ConsultaIndex,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('consultaSigep')) next()
                else next({name: "error_permisos"})
        },
    },
    {
        path: '/comprobar',
        name: 'comprobar',
        component: ComprobarIndex,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('administrador')) next()

            else next({name: "error_permisos"})
        }
    },
    {
        path: '/reporte-cajero',
        name: 'reporte-cajero',
        component: ReporteCajero,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('administrador')) next()

            else next({name: "error_permisos"})
        }
    },
    {
        path: '/resumenes',
        name: 'resumenes',
        component: Resumenes,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('administrador')) next()

            else next({name: "error_permisos"})
        }
    },
    {
    path: '/reporte-banco',
    name: 'reporte_banco',
    component: ReportesBanco,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
        if (UserAuth.can('administrador')) {
            next();
        } else {
            next({ name: 'error_permisos' });
        }
    }
    },
    {
    path: '/reporte-bancamovil',
    name: 'reporte_bancamovil',
    component: ReporteCajeroBanco,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
        if (UserAuth.can('administrador')) {
            next();
        } else {
            next({ name: 'error_permisos' });
        }
    }
    },
    {
        path: '/404',
        name: 'error',
        component: () => import('../components/Error.vue'),
    },
    {
        path: '/403',
        name: 'error_permisos',
        component: () => import('../components/ErrorPermisos.vue'),
    },
    {
        path: '/',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (UserAuth.isLogin())
            next()
        else
            next('/403');
    }
    else
        next()
});

export default router
